import { render } from "./eConstructionProfessional.vue?vue&type=template&id=23a45a58"
import script from "./eConstructionProfessional.vue?vue&type=script&lang=js"
export * from "./eConstructionProfessional.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__